export default __webpack_public_path__ + "static/media/bills.7ac73c28.svg";